/* Classify existing blocks without moving or duplicating purchase controls. */
if (!customElements.get('mobile-product-details')) {
  customElements.define('mobile-product-details', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-mobile-layout') || !this.closest('.main-product-information')) return;
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this, { childList: true, subtree: true });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.arrange());
    }

    highlightPromotion(item) {
      const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.parentElement.closest('script, style, .mobile-promotion-discount') && /Up\s+to\s+\d+(?:\.\d+)?%\s+OFF/i.test(node.data)) nodes.push(node);
      }
      for (const node of nodes) {
        const fragment = document.createDocumentFragment();
        let offset = 0;
        for (const match of node.data.matchAll(/Up\s+to\s+\d+(?:\.\d+)?%\s+OFF/gi)) {
          fragment.append(node.data.slice(offset, match.index));
          const emphasis = document.createElement('span');
          emphasis.className = 'mobile-promotion-discount';
          emphasis.textContent = match[0];
          fragment.append(emphasis);
          offset = match.index + match[0].length;
        }
        fragment.append(node.data.slice(offset));
        node.replaceWith(fragment);
      }
    }

    arrange() {
      const content = this.querySelector(':scope > .group-block > .group-block-content');
      if (!content) return;
      content.classList.add('mobile-detail-layout');
      for (const item of content.children) {
        if (item.matches('script, style, link, template, side-drawer')) continue;
        const has = selector => item.matches(selector) || !!item.querySelector(selector);
        const text = item.textContent.trim();
        let role = 'extra';
        if (has('h1, .product-title')) role = 'title';
        else if (has('product-price')) role = 'price';
        else if (has('.accordion')) role = 'accordion';
        else if (has('.multicolumn--product-specs')) role = 'specs';
        else if (has('.launch-offer-countdown')) role = 'offer-countdown';
        else if (has('variant-selects')) role = 'variants';
        else if (has('#dynamic-variant-desc, .variant-desc-box')) role = 'variant-note';
        else if (has('.productView-hotStock')) role = 'hot-stock';
        else if (has('delivery-time, .delivery-time')) role = 'delivery';
        else if (has('.buy-buttons-block')) role = 'buy';
        else if (has('.product-key-features-popup')) role = 'key-features';
        else if (has('.payment-icons__list')) role = 'payments';
        else if (has('.list-social, .social-icons, .social-share, .product-share-button')) role = 'social';
        else if (/Official Store Benefits/i.test(text)) role = 'benefits';
        else if (/Grand Opening.*Sale/i.test(text)) role = 'promotion';
        else if (has('[class*="ag-review"], [class*="air-review"], [class*="airreviews" i], [id*="airreviews" i], [class*="jdgm-preview"], [class*="spr-badge"], [id*="app_summary"], [id*="app-summary"], .rating')) role = 'reviews';
        else if (item.matches('.text-block, rte-formatter, text-animation') && text) role = 'description';
        item.dataset.mobileDetail = role;
        if (role === 'promotion') this.highlightPromotion(item);
      }
      const variants = content.querySelector('[data-mobile-detail="variants"]');
      content.classList.toggle('mobile-detail-has-variants', !!variants);
    }
  });
}
